import vrExperienceBackground from '../assets/vrExperienceBackground.svg'

function VRExperience () {
    return (
        <div style={{backgroundImage: `url(${vrExperienceBackground})`, backgroundSize: 'cover', height: '100vh', backgroundRepeat: 'no-repeat'}}>

        </div>
    )
}

export default VRExperience;